import React, { Fragment, FC, memo, useEffect } from 'react';

import Banner from './components/Banner/Banner';
import DiscoverHow from './components/DiscoverHow/DiscoverHow';
import Features from './components/Features/Features';
import OurRepository from './components/OurRespository/OurRepository';
import Partners from './components/Partners/Partners';
import Plans from './components/Plans/Plans';
import Testimonials from './components/Testimonials/Testimonials';
import TopBar from './components/TopBar/TopBar';
import FAQ from './components/FAQ/FAQ';

import { findParamFromUrl, setMetaTags, trackAnalytics } from 'common/utils/app.utils';
import { META_TAGS, ROUTES } from 'common/constants/app.constants';
import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';

import './index.scss';
import ContactUs from './components/contactUs/ContactUs';
import { trackGTM } from 'app-layout/utils';
import BusninessConnection from './components/BusninessConnection/BusninessConnection';

export const UnauthView: FC<DedicatedRouteProps> = (props) => {
  const { history } = props;

  const redirectToCheckFeasibilityPage = (data: any = null) => {
    const productType = findParamFromUrl('productType', false) ?? 'DEDICATED_INTERNET';
    const historyState = data ? { ...data } : null;

    let redirectUrl = ROUTES.DEDICATED_HOME;
    const accessToken = localStorage.getItem("accessToken") ? localStorage.getItem("accessToken") : '';
    if(!accessToken || accessToken=== 'null'){
      redirectUrl = ROUTES.DEDICATED_CHECK_FEASIBILITY;
      if (productType) {
        redirectUrl = redirectUrl + '?productType=' + productType;
      }
      let href=window && window.location && window.location.href;
      href = href && href.slice(0, href.lastIndexOf('/'));
      href=href+redirectUrl;
      //history?.push(redirectUrl, { ...historyState });
      window.location.replace(href);
    } else{
      if (productType) {
        redirectUrl = redirectUrl + '?productType=' + productType;
      }
  
     
    }
   
    
  };

  const handleBannerBtnClick = (e: any) => {
    e.preventDefault();
    trackAnalytics({
      eVar9: 'b2b| dedicated internet| landing page| check availability',
      prop0: 'b2b| dedicated internet'
    });
    redirectToCheckFeasibilityPage();
    trackGTM('checkAvailability', 'forme|internet_leased_line|homepage');
  };

  const handlePlanClick = (e: any, selectedBandwidth: string) => {
    e.preventDefault();
    trackAnalytics({
      eVar9: 'b2b| dedicated internet| landing page| check availability',
      prop0: 'b2b| dedicated internet',
      prop18: selectedBandwidth
    });
    redirectToCheckFeasibilityPage({ bandwidth: selectedBandwidth });
    trackGTM('checkAvailability', 'forme|internet_leased_line|homepage');
  };

  useEffect(() => {
    trackAnalytics({
      eVar0: 'b2b| dedicated internet| landing page',
      prop0: 'b2b| dedicated internet'
    });
    trackGTM('SPAPV', 'forme|internet_leased_line|homepage');
    setMetaTags(META_TAGS.B2B_HOME);
  }, []);

  // render unauth page for ILL/MPLS
  return (
    <Fragment>
      <div className="unauth-view home_content">
        <div className="inside_content">
          <Banner onBtnClick={handleBannerBtnClick} />
          <TopBar />
          <Plans onPlanClick={handlePlanClick} />
          <Features />
          {/* <Partners /> */}
          <div className="thumbnail_section">
            <DiscoverHow />
            <Testimonials />
          </div>
          <OurRepository />
          <ContactUs />
          <FAQ />
          <BusninessConnection />
        </div>
      </div>
    </Fragment>
  );
};

export default memo(UnauthView);
